export const ROUTES = [
  { id: "dashboard", path: "/dashboard", label: "Dashboard", shortLabel: "Dashboard", icon: "home" },
  { id: "planung", path: "/planung", label: "Planung", shortLabel: "Planung", icon: "calendar" },
  { id: "kapazitaet", path: "/kapazitaet", label: "Kapazität", shortLabel: "Kapazität", icon: "gauge" },
  { id: "projekte", path: "/projekte", label: "Projekte", shortLabel: "Projekte", icon: "list" },
  { id: "bestaetigungen", path: "/bestaetigungen", label: "Bestätigungen", shortLabel: "Bestät.", icon: "checkCircle", query: ["mandatId", "bestaetigungId"] },
  { id: "offerten", path: "/offerten", label: "Offerten", shortLabel: "Offerten", icon: "send" },
  { id: "team", path: "/team", label: "Team", shortLabel: "Team", icon: "users" },
];

export const ADMIN_ROUTE = { id: "administration", path: "/administration", label: "Administration", shortLabel: "Admin", icon: "settings" };

export const routeFromPath = (pathname) => [ADMIN_ROUTE, ...ROUTES].find((route) => pathname === route.path || pathname.startsWith(`${route.path}/`)) || ROUTES[0];
